import { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { FormattedMessage } from 'react-intl';
import LoadingEvent from '../UI/Skeleton/LoadingEvent';
import FormErrorsArray from './FormErrorsArray';

function FormUrlDataProcessor({ onLoad, children, onError }) {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(null);

  const initialize = async () => {
    setLoading(true);
    try {
      const result = await onLoad();
      if (result.errors) {
        setErrors(result.errors);
      }
    } catch (e) {
      setErrors({ message: e.message });
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  if (loading) {
    return (
      <LoadingEvent>
        <FormattedMessage id="LOADING" defaultMessage="Loading" />
      </LoadingEvent>
    );
  }
  if (errors) {
    return (
      <Box>
        <FormErrorsArray errors={errors} />
        <Box sx={{ textAlign: 'center' }}>
          <Button
            startIcon={<ArrowBackIosNewIcon />}
            variant="contained"
            onClick={() => {
              onError();
            }}>
            <FormattedMessage id="Back" defaultMessage="Back" />
          </Button>
        </Box>
      </Box>
    );
  }

  return children;
}

export default FormUrlDataProcessor;
